import { useCallback, useState } from "react";
import Api from "../services/Api";
import { subscribeToChatUpdates } from "../services/Wamp";
import { useFocusEffect } from "@react-navigation/core";

const useUnreadChatMessageCount = (accessToken) => {
    const [unreadChatMessageCount, setUnreadChatMessageCount] = useState(0);

    useFocusEffect(useCallback(() => {
        if (!accessToken) {
            return;
        }

        Api.getUnreadMessagesCount(accessToken).then((unread) => {
            setUnreadChatMessageCount(unread);
        });

        const unsubFromChatUpdates = subscribeToChatUpdates(([{ type, unreadMessagesCount }]) => {
            if (type !== "chat-marked-as-read" && type !== "new-message") {
                return;
            }

            unreadMessagesCount = typeof unreadMessagesCount === "number" ? unreadMessagesCount : Number.parseInt(unreadMessagesCount, 10);
            if (!Number.isSafeInteger(unreadMessagesCount)) {
                return;
            }

            setUnreadChatMessageCount(unreadMessagesCount);
        });

        return () => {
            unsubFromChatUpdates();
        };
    }, [accessToken]));

    return unreadChatMessageCount;
};

export default useUnreadChatMessageCount;